export const PICK_VIDEO_STEP = 'pick_video';
export const CROP_VIDEO_STEP = 'crop_video';
